module.exports = __webpack_public_path__ + "img/bankmisr.c8e76086.png";